
export default function Services() {
  const services = [
    {
      icon: 'ri-pencil-ruler-2-line',
      title: '内装工事の設計・監理',
      description: '専門スタッフが、お客様のニーズに合わせた内装設計を提案し、施工の監理まで一貫してサポートいたします。品質管理を徹底し、理想の空間づくりをお手伝いします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20design%20blueprint%20and%20architectural%20planning%20on%20wooden%20desk%20with%20natural%20forest%20elements%2C%20clean%20minimalist%20workspace%2C%20design%20tools%20and%20materials%2C%20soft%20natural%20lighting%2C%20professional%20photography%20style%2C%20simple%20background&width=600&height=400&seq=service-design-001&orientation=landscape'
    },
    {
      icon: 'ri-palette-line',
      title: '内装材料の選定コンサルティング',
      description: '最新のトレンドと機能性を考慮した内装材料の選定をサポート。環境に配慮した素材から高級素材まで、予算とニーズに応じた最適な提案を行います。',
      image: 'https://readdy.ai/api/search-image?query=Various%20interior%20material%20samples%20including%20wood%2C%20fabric%2C%20and%20natural%20textures%20arranged%20beautifully%20on%20clean%20surface%2C%20professional%20consultation%20setting%2C%20natural%20forest%20inspired%20materials%2C%20soft%20lighting%2C%20minimalist%20composition%2C%20simple%20background&width=600&height=400&seq=service-material-001&orientation=landscape'
    },
    {
      icon: 'ri-presentation-line',
      title: 'オンライン講座・セミナー',
      description: '内装工事に関する専門知識を学べるオンライン講座やセミナーを定期的に開催。初心者から専門家まで、幅広い層に対応したカリキュラムをご用意しています。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20online%20seminar%20setup%20with%20laptop%20and%20presentation%20materials%20in%20natural%20wooden%20environment%2C%20professional%20learning%20atmosphere%2C%20clean%20workspace%2C%20forest%20inspired%20decor%2C%20soft%20natural%20light%2C%20minimalist%20style%2C%20simple%20background&width=600&height=400&seq=service-seminar-001&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'トータルサポートサービス',
      description: '企画から完成まで、内装工事のすべての工程をワンストップでサポート。お客様の負担を最小限に抑え、スムーズなプロジェクト進行を実現します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20support%20team%20working%20together%20in%20natural%20wooden%20office%20space%2C%20collaborative%20atmosphere%2C%20modern%20workspace%20with%20forest%20elements%2C%20friendly%20service%20environment%2C%20clean%20and%20organized%2C%20soft%20lighting%2C%20simple%20background&width=600&height=400&seq=service-support-001&orientation=landscape'
    },
    {
      icon: 'ri-information-line',
      title: '情報提供サイトの運営',
      description: '内装工事に関する最新情報、トレンド、施工事例などを発信する情報サイトを運営。お客様の意思決定をサポートする有益な情報を提供しています。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20website%20and%20digital%20information%20platform%20displayed%20on%20devices%20in%20natural%20wooden%20setting%2C%20clean%20interface%20design%2C%20forest%20inspired%20workspace%2C%20professional%20digital%20content%2C%20minimalist%20style%2C%20soft%20natural%20lighting%2C%20simple%20background&width=600&height=400&seq=service-info-001&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            サービス内容
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様のニーズに合わせた、充実したサービスラインナップをご用意しています
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-full">
                  <i className={`${service.icon} text-2xl text-emerald-700`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-emerald-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
